<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="客服组"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
      <el-form-item label="服务平台" required>
        <el-checkbox-group v-model="selectPlatform">
          <el-checkbox :label="item.value" v-for="(item,i) in platformList" :key="i">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="头像" >
        <avatar-uploader
          @getImgUrl="(v) => (form.avatar = v)"
          :url="form.avatar"
        ></avatar-uploader>
      </el-form-item>
       </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
import {platformList} from '../../../knowledgeManage/components/dict'
export default {
  data() {
    return {
        selectPlatform:[],
      platformList,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      venue_id: "",
    };
  },

  mounted() {
  },
  methods: {
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.selectPlatform = this.form.platform.split(',')
        
      } else {
        this.form = {};
        this.selectPlatform = []
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
        if(this.selectPlatform.length == 0){
            this.$message('请选择服务平台')
            return
        }
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
         if(this.selectPlatform.length == 0){
            this.$message('请选择服务平台')
            return
        }
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/chat/customerServiceGroup/insert";
      this.form.platform = this.selectPlatform.join(',');
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      this.form.platform = this.selectPlatform.join(',');
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/chat/customerServiceGroup/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>